import { TransactionIdAndType, LinkedTransactionsMap, EftWithdrawTransactionResponse, TransactionType } from 'vopay';
import { useEffect, FC, useState } from 'react';
import { useParams } from 'react-router-dom';
import EftWithdrawTransactionInfo from './EftWithdrawTransactionInfo';
import useFetchEFTWithdrawTransaction from '@/hooks/useApi/useFetchEFTWithdrawTransaction';
import LinkedTransactionInfo from '@/components/Transaction/LinkedTransactionInfo';
import useAccountBearer from '@/components/Entities/hooks/useApi/useAccountBearer';

const EftWithdrawTransactionContainer: FC<TransactionIdAndType> = ({ TransactionID, Type }: TransactionIdAndType) => {
  const { accountId } = useParams<{ accountId: string }>();
  const { bearer: token } = useAccountBearer(accountId);
  const [isDataFeched, setIsDataFeched] = useState(false);
  const [parentTransactions, setParentTransactions] = useState<LinkedTransactionsMap>();

  const [eftWithdrawTransaction, getEftWithdrawTransaction] = useFetchEFTWithdrawTransaction({
    bearer: token,
  });

  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<EftWithdrawTransactionResponse>();

  useEffect(() => {
    if (!token) return;

    if (Type === TransactionType.EFT_WITHDRAWAL) {
      getEftWithdrawTransaction(TransactionID);
    }

    setIsDataFeched(true);
  }, [currentTransactionId, token]);

  useEffect(() => {
    if (isDataFeched && Object.values(eftWithdrawTransaction).length > 0 && eftWithdrawTransaction.ParentTransaction) {
      const subTransactionsList: LinkedTransactionsMap = Object.values(eftWithdrawTransaction.ParentTransaction);

      setParentTransactions(subTransactionsList);
    }
  }, [eftWithdrawTransaction]);

  useEffect(() => {
    if (eftWithdrawTransaction) {
      setTransaction(eftWithdrawTransaction);
    }
  }, [eftWithdrawTransaction]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && transaction.TransactionID !== '' && <EftWithdrawTransactionInfo transaction={transaction} />}
      {parentTransactions && <LinkedTransactionInfo LinkedTransactions={parentTransactions} />}
    </div>
  );
};

export default EftWithdrawTransactionContainer;
